module.exports = __webpack_public_path__ + "static/media/occlusion.5d1d114a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/occlusion.svg
// module id = 192
// module chunks = 0